import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import ClearIcon from '@mui/icons-material/Clear';
import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material';

const commandComponents = {
  edit: EditIcon,
  commit: SaveIcon,
  cancel: ClearIcon,
  delete: DeleteIcon
};

export const Command = ({ id, onExecute, text }) => {
  const theme = useTheme();
  const CommandIcon = commandComponents[id];

  const color = id === 'commit' ? theme.palette.primary.main : id === 'cancel' ? theme.palette.secondary.main : theme.palette.text.icon;

  return (
    <Tooltip title={text} key={`${text}-key`}>
      <Box component="span">
        <Button
          variant="contained"
          color="secondary"
          aria-label={text}
          onClick={onExecute}
          sx={{
            p: 0.25,
            mr: 0.25,
            cursor: 'pointer',
            minWidth: 'unset',
            color,
            bgcolor: 'background.paper',
            '&:hover':
              id === 'commit' || id === 'cancel'
                ? {
                    color: 'primary.contrastText',
                    bgcolor: 'primary.main'
                  }
                : {
                    color: 'text.secondary',
                    bgcolor: 'background.default'
                  }
          }}
        >
          <CommandIcon fontSize="small" />
        </Button>
      </Box>
    </Tooltip>
  );
};
